import { useState, useEffect } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import { GridColDef, GridRowParams, MuiEvent } from '@mui/x-data-grid';
import { createTheme } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import axios from "axios";
import { useForm, Resolver, SubmitHandler } from "react-hook-form";
import IconButton from '@mui/material/IconButton';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import CloseIcon from '@mui/icons-material/Close';
import SmartphoneIcon from '@mui/icons-material/Smartphone';
import EmailIcon from '@mui/icons-material/Email';
import Link from '@mui/material/Link';
import { IUser } from "../../interfaces/IUser";
import { alpha, styled } from '@mui/material/styles';
import { DataGrid, gridClasses } from '@mui/x-data-grid';
import { setPageTitle } from "../../slices/applicationSlice";
import { IApplication } from "../../interfaces/IApplication";
import { useAppDispatch } from "../../hooks";
import ActionButton from "../../components/ActionButton";
import ActionMenu from "../../components/ActionMenu";

const ODD_OPACITY = 0.2;

const StripedDataGrid = styled(DataGrid)(({ theme }) => ({
  [`& .${gridClasses.row}.even`]: {
    backgroundColor: theme.palette.grey[300],
    '&:hover, &.Mui-hovered': {
      backgroundColor: alpha(theme.palette.primary.main, ODD_OPACITY),
      '@media (hover: none)': {
        backgroundColor: 'transparent',
      },
    },
    '&.Mui-selected': {
      backgroundColor: alpha(
        theme.palette.primary.main,
        ODD_OPACITY + theme.palette.action.selectedOpacity,
      ),
      '&:hover, &.Mui-hovered': {
        backgroundColor: alpha(
          theme.palette.primary.main,
          ODD_OPACITY +
            theme.palette.action.selectedOpacity +
            theme.palette.action.hoverOpacity,
        ),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: alpha(
            theme.palette.primary.main,
            ODD_OPACITY + theme.palette.action.selectedOpacity,
          ),
        },
      },
    },
  },
}));


const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

export interface DialogTitleProps {
  id: string;
  children?: React.ReactNode;
  onClose: () => void;
}

function BootstrapDialogTitle(props: DialogTitleProps) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}





type Anchor = 'top' | 'left' | 'bottom' | 'right';



const resolver: Resolver<IUser> = async (values) => {
  return {
    values: values.firstName ? values : {},
    errors: !values.firstName
      ? {
        firstName: {
          type: 'required',
          message: 'This is required.',
        },
      }
      : {},
  };
};

export default function Users() {
  
  function UserClicked(_event: React.MouseEvent<HTMLElement>): void {
    
    setOpen(true);
  }

  

  const [open, setOpen] = useState(false);

  function handleClose() {
    setOpen(!open);
  }

  const buttons = [
    <ActionButton action={UserClicked} buttonLabel="ADD NEW USER" />,
 
  ];


  const dispatch = useAppDispatch();

  useEffect(() => {
    let appState: IApplication = {
      pageTitle: "Users",
      backgroundPath: "/assets/images/growing.jpg"
    }
    dispatch(setPageTitle(appState));
  }, []);

  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });

  const [rows, setRows] = useState<IUserRow[]>([]);

  useEffect(() => {
    GetGridData(setRows);
  }, []);



  const { register, handleSubmit, control, formState: { errors }, reset, setValue, getValues } = useForm<IUser>({ resolver });

  const onSubmit: SubmitHandler<IUser> = data => {
    console.log("In Submit");
    if (data.id > 0) {
      console.log(data.active);
      axios.put(`${process.env.REACT_APP_ENDPOINT}/api/Users/${data.id}`, {
        id: data.id,
        employeeId: data.employeeId,
        firstName: data.firstName,
        lastName: data.lastName,
        userName: data.userName,
        email: data.email,
        phone: data.phone,
        password: data.password,
        passwordHint: data.passwordHint,
        notes: data.notes,
        active: data.active
      }).then((data) => {
        console.log(data);
        if (data.status === 204) {
          reset();
          setOpen(false);
          GetGridData(setRows);
        };
      });
    } else {
      axios.post(`${process.env.REACT_APP_ENDPOINT}/api/Users`, {
        employeeId: data.employeeId,
        firstName: data.firstName,
        lastName: data.lastName,
        userName: data.userName,
        email: data.email,
        phone: data.phone,
        password: data.password,
        passwordHint: data.passwordHint,
        notes: data.notes,
        active: data.active
      }).then((data) => {
        console.log(data);
        if (data.status === 201) {
          reset();
          setOpen(false);
          GetGridData(setRows);
        };
      });
    }
  };
  
  const [helpOpen, setHelpOpen] = React.useState(false);

  const handleClickOpen = () => {
    reset();
    setOpen(true);
  };

  const handleClickHelpOpen = () => {
    setHelpOpen(true);
  };

  const handleHelpClose = () => {
    setHelpOpen(false);
  };

 

  const handleDoubleClick = (x: GridRowParams<any>, y: MuiEvent<React.MouseEvent<HTMLElement, MouseEvent>>) => {
    console.log(x.row.active);
    setValue('id', x.row.id);
    setValue('employeeId', x.row.employeeId);
    setValue('firstName', x.row.firstName);
    setValue('lastName', x.row.lastName);
    setValue('userName', x.row.userName);
    setValue('phone', x.row.phone);
    setValue('email', x.row.email);
    setValue('password', x.row.password);
    setValue('passwordHint', x.row.passwordHint);
    setValue('notes', x.row.notes);
    setValue('active', x.row.active);
    setOpen(true);
  }



  const columns: GridColDef[] = [
    //{ field: 'id', headerName: 'ID', width: 50, hide: true },
    { field: 'employeeId', headerName: 'ID', width: 50 },
    { field: 'firstName', headerName: 'First Name', width: 100 },
    { field: 'lastName', headerName: 'Last Name', width: 100 },
    { field: 'fullName', headerName: 'Full Name', width: 150 },
    { field: 'userName', headerName: 'User Name', width: 150 },
    { field: 'phone', headerName: 'Phone', width: 150 },
    { field: 'email', headerName: 'Email', width: 200, },
    { field: 'notes', headerName: 'Notes', flex: 1 },
    { field: 'active', headerName: 'Active', width: 0, hide: true }
  ];

  interface IUserRow {
    firstName: string,
    lastName: string,
    fullName: number,
    userName: string,
    email: string,
    phone: string,
    timezone: string,
    countryCode: string,
    password: string,
    passwordHint: string,
    notes: string,
    token: string,
    createdAt: any,
    updatedAt: any,
    active: boolean
  }

  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#010101' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    border: 0,
    borderRadius: 0,
    boxShadow: "none",
  }));

  const darkTheme = createTheme({
    palette: {
      mode: 'dark',
      primary: {
        main: '#89B219',
      },
    },
  });

  const handleDelete = () => {
    console.info('You clicked the delete icon.');
  };

  function GetGridData(setRows: React.Dispatch<React.SetStateAction<IUserRow[]>>) {
    console.log(process.env.REACT_APP_ENDPOINT);
    axios
      .get(`${process.env.REACT_APP_ENDPOINT}/api/Users`)
      .then(res => {
        setRows(res.data);
      });
  }

  return (

    <div>
      <ActionMenu buttons={buttons} />
      <Grid container spacing={0} bgcolor="#101010" >

{/*         <Box sx={{ flexGrow: 1 }}>
          <AppBar position="static" sx={{ bgcolor: "#101010" }}>
            <Toolbar>
              <Typography variant="h5" fontWeight="700" component="div" sx={{ flexGrow: 1 }}>
                User Management
              </Typography>
            </Toolbar>
          </AppBar>
        </Box> */}

        <Grid item xs={12}>
          <Item>
            <div style={{ height: 'calc(100vh - 76px)', width: '100%' }}>
              <StripedDataGrid
                rows={rows}
                columns={columns}
                pageSize={20}
                rowsPerPageOptions={[20]}
                sx={{ borderColor: 'rgba(100,100,100,0.2)' }}
                onRowDoubleClick={(x, y) => handleDoubleClick(x, y)}
                getRowClassName={(params) =>
                  params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
                }
              />
            </div>
          </Item>
        </Grid>
      </Grid>

      <div>
        <BootstrapDialog
          onClose={handleHelpClose}
          aria-labelledby="customized-dialog-title"
          open={helpOpen}
        >
          <BootstrapDialogTitle id="customized-dialog-title" onClose={handleHelpClose}>
            Need Support?
          </BootstrapDialogTitle>
          <DialogContent dividers>
            <Typography sx={{ mb: 3 }} variant="body2" gutterBottom>
              If you are having issues or have questions, please contact us below.
            </Typography>
            <Button size='large' fullWidth variant="contained" startIcon={<SmartphoneIcon />} sx={{ mb: 1, bgcolor: '#89B219' }}>
              <Link href="tel:8003141797" underline="none" color="#FFF"><Typography variant='h6' fontWeight={700}>800-314-1797</Typography></Link>
            </Button>
            <Button size='large' fullWidth variant="contained" startIcon={<EmailIcon />} sx={{ mb: 1, bgcolor: '#89B219' }}>
              <Link href="mailto:bobs-market@idatp.com" underline="none">
                <Typography variant='h6' fontWeight={700} color="#FFF">bobs-market@idatp.com</Typography></Link>
            </Button>
          </DialogContent>
        </BootstrapDialog>
      </div>

      <div>
        <Dialog
          onClose={handleClose}
          aria-labelledby="customized-dialog-title"
          open={open}
        >
          <DialogTitle>
            Need Support?
          </DialogTitle>
          <DialogContent dividers>
            <Typography sx={{ mb: 3 }} variant="body2" gutterBottom>
              If you are having issues or have questions, please contact us below.
            </Typography>
            <Button size='large' fullWidth variant="outlined" color='inherit' startIcon={<SmartphoneIcon />} sx={{ mb: 1 }}>
              <Typography variant='h6' fontWeight={700}>800-314-1797</Typography>
            </Button>
            <Button size='large' fullWidth variant="outlined" color="inherit" startIcon={<EmailIcon />}>
              <Typography variant='h6' fontWeight={700}>support@idatp.com</Typography>
            </Button>
          </DialogContent>
        </Dialog>
      </div>

      <Dialog open={open} onClose={handleClose} maxWidth='lg' fullWidth>
        <DialogTitle>Create a New User</DialogTitle>
        <Box component="form" onSubmit={handleSubmit(onSubmit)}>
          <DialogContent>
            <TextField id="id" label="id" variant="outlined" fullWidth sx={{ display: 'none' }} {...register("id")} />
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Item><TextField id="employeeId" label="Employee ID" variant="outlined" fullWidth {...register("employeeId")} /></Item>
              </Grid>
              <Grid item xs={4}>
                <Item><TextField id="firstName" label="First Name" variant="outlined" fullWidth {...register("firstName")} /></Item>
              </Grid>
              <Grid item xs={4}>
                <Item><TextField id="lastName" label="Last Name" variant="outlined" fullWidth {...register("lastName")} /></Item>
              </Grid>
              <Grid item xs={4}>
                <Item><TextField id="userName" label="User Name" variant="outlined" fullWidth {...register("userName")} /></Item>
              </Grid>
              <Grid item xs={4}>
                <Item><TextField id="phone" label="Cell Phone" variant="outlined" fullWidth {...register("phone")} /></Item>
              </Grid>
              <Grid item xs={8}>
                <Item><TextField id="email" label="Email" variant="outlined" type="email" fullWidth {...register("email")} /></Item>
              </Grid>
              <Grid item xs={4}>
                <Item><TextField id="password" label="Password" variant="outlined" type="password" fullWidth {...register("password")} /></Item>
              </Grid>
              <Grid item xs={8}>
                <Item><TextField id="passwordHint" label="Password Hint" variant="outlined" type="text" fullWidth {...register("passwordHint")} /></Item>
              </Grid>
              <Grid item xs={10}>
                <Item><TextField id="notes" label="Notes" variant="outlined" type="text" fullWidth {...register("notes")} /></Item>
              </Grid>
              <Grid item xs={2}>
                <Item>
                  <FormControlLabel
                    control={<Switch color="secondary" {...register("active")} />}
                    label="Active"
                    labelPlacement="top"
                  />
                </Item>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button variant="outlined" onClick={handleClose}>Cancel</Button>
            {getValues("id")
              ? <Button type='submit' variant="contained" size="large" color="success">UPDATE</Button>
              : <Button type='submit' variant="contained" size="large" color="success">CREATE</Button>
            }
          </DialogActions>
        </Box>
      </Dialog>
    </div>
  );
}

